import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {AuthService} from 'src/app/shared/services/auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuardService {

  private roles;

  constructor(
    protected router: Router,
    private keycloak: KeycloakService,
    private authService: AuthService,
  ) {

    this.roles = this.authService.getRoles();
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.keycloak.isLoggedIn()) {
      // cause redirect to login page
      this.keycloak.login({
        scope: 'offline_access'
      });
      return false;
    }
    const role = route.data["role"];

    if (role == undefined) {
      return true;
    }

    if (this.roles.includes(`${role}:active`)) {
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }

}
